<script setup lang="ts"></script>

<template>
  <div id="offcanvasDashboardWhatsNew" class="offcanvas offcanvas-end" tabindex="-1">
    <div class="offcanvas-body">
      <h5>What's New</h5>
      <hr />
      <div>
        <h3>Redesigned Case List</h3>
        <ul>
          <li>
            In addition to applying a more modern design style, we have reduced the height of the Case cards and
            reorganized the data to fit more Cases on the screen.
          </li>
          <li>
            We have removed the Data section and replaced it with icons in the lower-right corner of the card. Note that
            the icons will only appear if data is present. Icon labels may be toggled on or off in the Options.
          </li>
        </ul>
        <br />
        <h3>Redesigned Case Details</h3>
        <ul>
          <li>
            The data has been rearranged to put more relevant information toward the top of the Case Details pane.
            Agency and Truck information is now visible directly below the Complaint, and you can assign a Room from
            within the Case, in addition to the card.
          </li>
          <li>
            We have removed the Map preview showing the ambulance's location and replaced it with a map icon to the
            right of the ETA. Click the icon to open the Map.
          </li>
          <li>
            Timers have been redesigned into an interactive section where you can mark the Case as “Arrived” from within
            the Case. We have also added a button to stop the “ED Time” timer when the patient has left the ED. Timers
            may be toggled on or off in the Options.
          </li>
          <li>
            If Team Activation protocols are enabled for your Hospital, we have redesigned this section to contain all
            protocols within a dropdown. Additionally, you may activate multiple protocols simultaneously; for example,
            your Registration Team may be activated through a separate pathway from Cardiology.
          </li>
        </ul>
        <br />
        <h3>Redesigned Timeline</h3>
        <ul>
          <li>
            We have added Filters to the Timeline to allow focus on only Media uploads or Chat messages. Timeline
            Filters may be toggled on or off in the Options.
          </li>
          <li>
            To reduce clutter and focus on the most relevant information, we have removed “Set Tag” events from the
            Timeline. An event will still be posted if a Tag is removed.
          </li>
        </ul>
        <br />
        <h3>User Menu</h3>
        <ul>
          <li>
            We have added several additional tools to a 3-line menu in the upper-right corner of the Dashboard. This is
            also where you manually log out.
          </li>
          <li>
            The What's New section allows you to keep up-to-date with any feature changes or other enhancements to the
            Dashboard. You will be automatically prompted when new content is available and can suppress these
            notifications until new content is added.
          </li>
          <li>
            The Options page allows you to customize the Dashboard's user interface for your individual needs and
            preferences.
          </li>
          <li>
            Feedback provides a link to a form where you can contact Twiage's Product Team to share your feedback on the
            Dashboard and any enhancements you feel would benefit you or your team.
          </li>
          <li>Help directs you to Twiage's Help Site, where you can access our FAQ articles and training materials.</li>
        </ul>
        <br />
        <h3>Improved Filters</h3>
        <ul>
          <li>
            Filters for Hospital, EMS Agency, and Complaints are now found in the new Filters menu on the bar below the
            TigerConnect logo. Simply check the boxes for the criteria you would like to filter by and click the “Apply
            Filters” button to save your changes. You can quickly remove all filters by reopening the menu and clicking
            “Clear Current Filters” at the top of the box.
          </li>
          <li>
            We have also added Quick Filters to allow you to quickly filter the displayed Cases by priority level. There
            is also an option to display an “Unacknowledged” Quick Filter to only display Cases that have been received
            but not yet interacted with by any member of your hospital. The way in which the Quick Filters are displayed
            can be adjusted in the Options menu.
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<style scoped>
.no-width {
  width: 0rem;
}
.new-feature {
  margin: 1rem;
}
.whats-new-content {
  height: 90%;
  width: 100%;
  overflow: hidden;
  font-family: sans-serif;
}
ul {
  list-style: circle;
}
li {
  margin-left: -1rem;
  padding: 0.5rem;
}
</style>
